import { get, sortBy } from "lodash";
import { createSelector } from "reselect";
import { getPageContent } from "../../shared/selectors";

const getUpgradeBundleGroups = createSelector([getPageContent], pageContent => {
  return sortBy(get(pageContent, "upgrade_bundle_groups", []), ["name"]);
});

export default getUpgradeBundleGroups;
